import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress } from "@mui/material";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import { RiHotelBedFill } from "react-icons/ri";
import { getChainIdLS, isValidRole } from "../../../utils/utils";
import DeleteMasterApkProviderConfig from "./DeleteMasterApkProviderConfig";
import { useSelector } from "react-redux";

function MasterApkProvider() {
  const [partnerConfigList, setPartnerConfigList] = useState([]);
  const [confirmDeletePartnerRow, setConfirmDeletePartnerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePartnerPopUp, setDeletePartnerPopUp] = useState(false);
  const [createPartnerSuccessMsg, setCreatePartnerSuccessMsg] = useState('');
  const [loader, setLoader] = useState(false);

  const {chainId} = useSelector((state) => state.chainIdReducer);
  let validPermissionClassName = isValidRole("MENU_CONFIGURATION_MASTER_APK_PROVIDER_MODIFY")
    ? ""
    : "btn-disable-permission";
 
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: 'onChange',
    defaultValues: { active: true }
  });

  const onSubmit = (data) => {
    let method = "POST";
    let url = `/master/apk/apps?appName=${data.appName}`;
    callAPI(url, method, {}, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
            appName: '',
        });
        setCreatePartnerSuccessMsg(response?.message);
        PartnerListApi();
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isPartnerDeletedRef = useRef({
    isPartnerDeletedModalData: null,
    userConformationModalData: null,
  });

  const deletePartnerConfigPopUpHandler = (row) => {
    setDeletePartnerPopUp(true);
    const newModalRefData = {
      isPartnerDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPartnerDeletedRef.current = newModalRefData;
  }

  const deletePartnerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePartnerRow === "") {
      return
    }

    if (confirmDeletePartnerRow === `Delete ${isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}`) {
      setConfirmValidate(false)
      const { row } = isPartnerDeletedRef.current?.isPartnerDeletedModalData;
      callAPI(`master/apk/apps?sid=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPartnerDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPartnerDeletedRef.current = newModalRefData;
          PartnerListApi();
        })
        .catch((error) => {
          setDeletePartnerPopUp(false);
          console.warn(error)
        });
    }
    reset({
        appName: '',
    });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("MENU_CONFIGURATION_MASTER_APK_PROVIDER_MODIFY")?
        <Tooltip title="Delete" className="cursor-pointer" arrow>
          <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deletePartnerConfigPopUpHandler(row);
            }}
          />
        </Tooltip>:<>
            <Tooltip title="Don't have permission to delete">
                <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
        </>
    );
  };

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "appName", headerName: "APK Provider Name", flex: 1 },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const PartnerListApi = () => {
    callAPI(`/master/apk/apps`, "GET",{}, { chainId: getChainIdLS() })
      .then((response) => {
        setPartnerConfigList(response)
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    PartnerListApi();
    cancelPartnerHandler()
  }, [chainId]);


  const popupCloseHandler = () => {
    setDeletePartnerPopUp(false);
  };

  const cancelPartnerHandler = () => {
    reset({
        appName: '',
    });
  }

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">APK Provider Configuration</p>
            </div>
            <div className="col-6">
              <div className="form-group-hotel">
                <div className="floating-label">
                  <RiHotelBedFill className="new-hotel-icons" />
                  <input
                    id="appName"
                    maxLength={25}
                    placeholder=""
                    {...register("appName", {
                      required: "APK Provider Name Required",
                    })}
                  />
                  <label htmlFor="appName">APK Provider Name</label>
                </div>
                {errors.appName && (
                  <small className="required">{errors.appName.message}</small>
                )}
              </div>
            </div>
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelPartnerHandler}>Clear All</button>
            <button type="submit" className={`create-btn ${validPermissionClassName} `}>Create</button>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>APK Provider Configuration List</b></p>

          <TableWrapper
            data={partnerConfigList}
            columns={columns}
            noPagination={true}
            module='default'
          />
        </div>
      </div>
      {deletePartnerPopUp && <DeleteMasterApkProviderConfig
        deletePartnerPopUp={deletePartnerPopUp}
        isPartnerDeletedRef={isPartnerDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deletePartnerHandler={deletePartnerHandler}
        setConfirmDeletePartnerRow={setConfirmDeletePartnerRow}
        confirmDeletePartnerRow={confirmDeletePartnerRow}
        confirmValidate={confirmValidate}
      />}
      <BasicModal
        popupOpen={createPartnerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPartnerSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePartnerSuccessMsg(''); PartnerListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  )
}

export default MasterApkProvider;